module.exports = __webpack_public_path__ + "img/zanwufajieqian.46740dea.png";